import React from "react";
import Layout from "./Layout";
import {
    Card,
    CardContent,
    Divider,
    ListItem,
    ListItemText,
    Typography,
    List,
    ListItemIcon,
    Zoom
} from "@mui/material";
import {Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot} from "@mui/lab";
import {AddCircle} from "@mui/icons-material";
import Footer from "./Footer";

const Experience = () => {
    const work = [
        {
            'company': 'Hughes Systique Corporation (HSC)',
            'position': 'Network Engineer Trainee',
            'time': 'Jan 2022 - Present',
            'description': [
                'Create and Manage Network Services',
                'Implement and Test Security Methodologies'
            ]
        },
        {
            'company': 'Virtually Testing Foundation',
            'position': 'Penetration Tester Intern',
            'time': 'Oct 2021 - Dec 2021',
            'description': [
                'Research about new vulnerabilities',
                'Upskilled by learning about new tools and attack methodologies'
            ]
        },
        {
            'company': 'Virtually Testing Foundation',
            'position': 'Cloud Security Associate',
            'time': 'July 2021 - Sept 2021',
            'description': [
                'Upskilled in AWS Cloud',
                'Upskilled in Cloud Security Methodologies'
            ]
        },
        {
            'company': 'PAC Security',
            'position': 'Penetration Tester Intern',
            'time': 'June 2021 - July 2021',
            'description': [
                'Bug Hunting on live websites',
                'Upskilled on Web Application Testing by doing hands-on projects'
            ]
        },
        {
            'company': 'Koders',
            'position': 'Application Developer Intern',
            'time': 'June 2020 - July 2020',
            'description': [
                'To Do List React Application',
                'Consent Management System using ethereum/solidity',
                'Client-Server Message Storing Service'
            ]
        },
    ]

    const Experience = () => {
        return (
            <div style={{marginTop: '10%', color: '#ffffff'}}>
                <div style={{alignContent: 'center', marginTop: '5%', marginBottom: '5%'}}>
                    <Zoom in={true} style={{transitionDuration: 2000}}>
                        <div>
                            <Typography variant="h3" component="h3"
                                        style={{fontWeight: 600, marginBottom: '1%', textAlign: 'center'}}>
                                Work Experience
                            </Typography>
                            <Timeline position='alternate'>
                                {work.map(item => (
                                    <TimelineItem>
                                        <TimelineSeparator>
                                            <TimelineDot />
                                            <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent>
                                            <Card style={{backgroundColor: '#2b2b2b', color: '#ffffff', padding: '2%'}}>
                                                <CardContent>
                                                    <Typography variant='h6' component='h6'>
                                                        {item.company}
                                                    </Typography>
                                                    <Divider/>
                                                    <div style={{marginTop: '1%'}}>
                                                        <Typography variant='body1' component='body1'>
                                                            {item.position} | {item.time}
                                                        </Typography>
                                                        <List>
                                                            {item.description.map(res => (
                                                                <ListItem>
                                                                    <ListItemIcon style={{color: '#ffffff'}}>
                                                                        <AddCircle />
                                                                    </ListItemIcon>
                                                                    <ListItemText>
                                                                        {res}
                                                                    </ListItemText>
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </TimelineContent>
                                    </TimelineItem>
                                ))}
                            </Timeline>
                        </div>
                    </Zoom>
                </div>
            </div>
        )
    };

    return (
        <Layout>
            <Experience />
            <Footer bgColor="#212121" />
        </Layout>
    )
};

export default Experience;